export default {
    // 미세먼지 등급
    pm10Level(val) {
        if(val == undefined) {
            return ['checking', '-', 0];
        }

        if(val >= 151) {
            return ['worse', '매우나쁨', 10];
        } else if(val >= 81 && val <= 150) {
            return ['bad', '나쁨', 20];
        } else if(val >= 31 && val <= 80) {
            return ['normal', '보통', 90];
        } else if(val >= 0 && val <= 30) {
            return ['good', '좋음', 100];
        } else {
            return ['checking', '점검중', 0];
        }
    },

    // 초 미세먼지 등급
    pm25Level(val) {
        if(val == undefined) {
            return ['checking', '-', 0];
        }

        if(val >= 76) {
            return ['worse', '매우나쁨', 10];
        } else if(val >= 36 && val <= 75) {
            return ['bad', '나쁨', 20];
        } else if(val >= 16 && val <= 35) {
            return ['normal', '보통', 90];
        } else if(val >= 0 && val <= 15) {
            return ['good', '좋음', 100];
        } else {
            return ['checking', '점검중', 0];
        }
    },

    // 이산화질소 등급
    no2Level(val) {
        if(val == undefined) {
            return ['checking', '-', 0];
        }

        if(val >= 0.201) {
            return ['worse', '매우나쁨', 10];
        } else if(val >= 0.061 && val <= 0.200) {
            return ['bad', '나쁨', 20];
        } else if(val >= 0.031 && val <= 0.060) {
            return ['normal', '보통', 90];
        } else if(val >= 0 && val <= 0.030) {
            return ['good', '좋음', 100];
        } else {
            return ['checking', '점검중', 0];
        }
    },

    // 오존 질소 등급
    o3Level(val) {
        if(val == undefined) {
            return ['checking', '-', 0];
        }

        if(val >= 0.151) {
            return ['worse', '매우나쁨', 10];
        } else if(val >= 0.091 && val <= 0.150) {
            return ['bad', '나쁨', 20];
        } else if(val >= 0.031 && val <= 0.090) {
            return ['normal', '보통', 90];
        } else if(val >= 0 && val <= 0.030) {
            return ['good', '좋음', 100];
        } else {
            return ['checking', '점검중'];
        }
    },

    // 대기 등급에 따른 색상
    getAirQaColor(grade) {
        let colorObj = {
            good: 'rgb(35,153,253)',
            normal: 'rgb(125,220,30)',
            bad: 'rgb(254,126,0)',
            worse: 'rgb(249,41,39)',
            checking: 'rgb(144,142,143)',
        }

        let color = colorObj[grade];

        if(typeof color !== 'undefined') {
            return color;
        } else {
            return "#96989B";
        }
    },
}
